import Vue from 'vue';
const {
  $gettext,
  $gettextInterpolate
} = Vue.prototype;
export default {
  defaultEntity: {
    type: 2,
    youtubes: [],
    photoFiles: [],
    directorName: '',
    directorPosition: '',
    question1: '',
    question2: '',
    question3: '',
    question4: '',
    question5: '',
    question6: '',
    question7: '',
  },
  layout(entity) {
    const {
      getters,
      state
    } = Vue.prototype.store;
    const {
      rules
    } = state.toggle;
    const {
      interviewTypes
    } = state.interview;
    const {
      courseDetail
    } = state.golfcourse;
    return [{
        fieldName: 'photoFiles',
        type: 'fileInput',
        maxPhoto: 1
      },
      {
        isTwoColum: true,
        fieldName: 'directorName',
        label: $gettext('Name'),
        rules: [rules.required]
      },
      {
        isTwoColum: true,
        fieldName: 'directorPosition',
        label: $gettext('Position'),
        rules: [rules.required]
      },
      {
        fieldName: 'question1',
        type: 'editorInput',
        label: $gettextInterpolate($gettext("Please tell us a bit about yourself. How long have you been managing %{name}"),{name: courseDetail.name})
      },
      {
        fieldName: 'question2',
        type: 'editorInput',
        label: $gettextInterpolate($gettext("What are your main objectives for %{name}?"),{name: courseDetail.name})
      },
      {
        fieldName: 'question3',
        type: 'editorInput',
        label: $gettextInterpolate($gettext("How would you describe %{name} in a nutshell? What are its key strengths?"),{name: courseDetail.name})
      },
      {
        fieldName: 'question4',
        type: 'editorInput',
        label: $gettextInterpolate($gettext("Is there any signature hole at %{name}? What makes it special or unique?"),{name: courseDetail.name})
      },
      {
        fieldName: 'question5',
        type: 'editorInput',
        label: $gettextInterpolate($gettext("Give us your pitch. Why should golfers come to %{name}?"),{name: courseDetail.name})
      },
      {
        fieldName: 'question6',
        type: 'editorInput',
        label: $gettextInterpolate($gettext("Which special events have been hosted at %{name} and/or will be in the future?"),{name: courseDetail.name})
      },
      {
        fieldName: 'question7',
        type: 'editorInput',
        label: $gettextInterpolate($gettext("Does %{name} organize its own events or does it plan to do so in the futre? (trophy, challenge, competition, etc.)"),{name: courseDetail.name})
      },
      {
        fieldName: 'youtubes',
        type: 'youtubeInput',
      }
    ];
  }
};